export enum ITaxFormType {
  TaxForm1099 = 'TAX_FORM_1099',
  TaxForm5498 = 'TAX_FORM_5498',
  TaxFormExcess1099 = 'TAX_FORM_EXCESS_1099',
}
export interface ITaxForm {
  id: string;
  name: string;
  type: ITaxFormType;
}